import { Navigate } from "react-router-dom";

import MainDashboard from "views/admin/default";

import SignIn from "views/auth/SignIn";
import SubaccountSelection from "views/auth/SubaccountSelection";
import ForgotPassword from "views/auth/ForgotPassword";
import AccountConfirmation from "views/public/AccountConfirmation";
import AccountConfirmationRedirect from "views/public/AccountConfirmationRedirect";
import KYCVerification from "views/public/KYCVerification";
import NotFound from "views/public/NotFound";
import Error from "views/public/Error";
import ExpiredLink from "views/public/ExpiredLink";

import { MdLock } from "react-icons/md";

import { HiOutlineClipboardDocumentCheck } from "react-icons/hi2";

import {
  AiOutlineStock,
  AiOutlineUserSwitch,
  AiOutlineSetting
} from "react-icons/ai";
import {
  PiUsersThree,
  PiUserCircle,
  PiCurrencyCircleDollar,
  PiStack,
  PiCreditCard,
} from "react-icons/pi";

import { TbUserDollar, TbCurrencyDollar } from "react-icons/tb";

import { FaRegUser } from "react-icons/fa";

import { GrTransaction } from "react-icons/gr";
import { LiaCoinsSolid } from "react-icons/lia";
import { FiActivity } from "react-icons/fi";
import { TbCloudDollar } from "react-icons/tb";
// import { TbTicket } from "react-icons/tb";
import { FaArrowTrendUp } from "react-icons/fa6";
import { MdOutlineSwapHorizontalCircle, MdOutlineSwitchAccount } from "react-icons/md";

import UserManagement from "views/admin/user";
import UserDetail from "views/admin/user/UserDetail";
import CreateUserWithoutInvitation from "views/admin/user/CreateUserWithoutInvitation";
import Payout from "views/admin/payout";
import Transaction from "views/admin/transaction";
import Fee from "views/admin/fee";
import CreatePayout from "views/admin/payout/CreatePayout";
import MerchantSelection from "views/auth/MerchantSelection";
import Batch from "views/admin/batch";
import BatchDetail from "views/admin/batch/BatchDetail";
// import BatchFailedReport from "views/admin/batch/BatchFailedReport";
import Receiver from "views/admin/receiver";
import CreateReceiver from "views/admin/receiver/CreateReceiver";
import ReceiverDetail from "views/admin/receiver/ReceiverDetail";
import ReceiverAccountSearch from "views/admin/receiver-account-search";
import AccountManagement from "views/admin/account";
import AccountDetail from "views/admin/account/AccountDetail";
import CreateAccount from "views/admin/account/CreateAccount";
import AgentManagement from "views/admin/agent";
import AgentDetail from "views/admin/agent/AgentDetail";
import ActivityLogs from "views/admin/activitylog";
import Profile from "views/admin/profile";
import MerchantManagement from "views/admin/merchant";
import CreateMerchant from "views/admin/merchant/CreateMerchant";
import MerchantDetail from "views/admin/merchant/MerchantDetail";
import Settings from "views/admin/settings";
import AgentDashboard from "views/admin/agentDashboard";
import AgentCommission from "views/admin/agentCommission";
import CreateAgent from "views/admin/agent/CreateAgent";
import TradingDesk from "views/admin/tradingDesk";
import Trade from "views/admin/trade";
import WhitelistAddress from "views/admin/whitelistAddress";
import AdminUtils from "views/admin/utils";
// import Helpdesk from "views/admin/helpdesk";

// Fee Group imports
import FeeGroupSubaccount from "views/admin/feeGroups/subaccount";
import FeeGroupSubaccountDetail from "views/admin/feeGroups/subaccount/FeeGroupSubaccountDetail";
import CreateFeeGroupSubaccount from "views/admin/feeGroups/subaccount/CreateFeeGroupSubaccount";
import FeeGroupAgent from "views/admin/feeGroups/agent";
import FeeGroupAgentDetail from "views/admin/feeGroups/agent/FeeGroupAgentDetail";
import CreateFeeGroupAgent from "views/admin/feeGroups/agent/CreateFeeGroupAgent";
import FeeGroupProvider from "views/admin/feeGroups/provider";
import FeeGroupProviderDetail from "views/admin/feeGroups/provider/FeeGroupProviderDetail";
import CreateFeeGroupProvider from "views/admin/feeGroups/provider/CreateFeeGroupProvider";

// Setup Wizard
import SetupWizard from "views/admin/setupWizard";

const useRoutes = (userPermissions: any | null) => {

  const userRole = localStorage.getItem("userRole");
  const merchantId = localStorage.getItem("merchantId");
  const subaccountId = localStorage.getItem("subaccountId");
  const subaccountType = localStorage.getItem("subaccountType");

  const permissionKey = `${merchantId}-${subaccountId}`;

  const authRoutes = [
    {
      isSideBar: false,
      name: "Select Merchant",
      layout: "/auth",
      path: "merchant-selection",
      icon: <MdLock className="h-6 w-6" />,
      component: <MerchantSelection />,
    },
    {
      isSideBar: false,
      name: "Select Subaccount",
      layout: "/auth",
      path: "subaccount-selection",
      icon: <MdLock className="h-6 w-6" />,
      component: <SubaccountSelection />,
    },
    {
      isSideBar: false,
      name: "Sign In",
      layout: "/auth",
      path: "sign-in",
      icon: <MdLock className="h-6 w-6" />,
      component: <SignIn />,
    },
    {
      isSideBar: false,
      name: "Forgot Password",
      layout: "/auth",
      path: "forgot-password",
      icon: <></>,
      component: <ForgotPassword />,
    }
  ];

  const publicRoutes = [
    {
      isSideBar: false,
      name: "Payout Confirmation",
      layout: "/",
      path: "confirm/:token",
      icon: <></>,
      component: <AccountConfirmation />,
    },
    {
      isSideBar: false,
      name: "KYC Verification",
      layout: "/",
      path: "kyc/:receiver_id",
      icon: <></>,
      component: <KYCVerification />,
    },
    {
      isSideBar: false,
      name: "Account Confirmation Redirect",
      layout: "/",
      path: "confirming/:receiver_account_id",
      icon: <></>,
      component: <AccountConfirmationRedirect />,
    },
    {
      isSideBar: false,
      name: "Not Found",
      layout: "/",
      path: "404",
      icon: <></>,
      component: <NotFound />,
    },
    {
      isSideBar: false,
      name: "Link Expired",
      layout: "/",
      path: "expired/:subaccountid",
      icon: <></>,
      component: <ExpiredLink />,
    },
    {
      isSideBar: false,
      name: "Internal Error",
      layout: "/",
      path: "500",
      icon: <></>,
      component: <Error />,
    }
  ];

  const getRoutesByPermission = () => {
    const routes = [];

    if (userRole === "SuperAdmin") {
      routes.push({
        isSideBar: true,
        name: "Dashboard",
        layout: `/${userRole?.toLowerCase() || ""}`,
        path: "dashboard",
        icon: <FaArrowTrendUp className="h-6 w-6" />,
        component: <MainDashboard />,
      });

      routes.push({
        isSideBar: true,
        name: "Payouts",
        layout: `/${userRole?.toLowerCase() || ""}`,
        icon: <PiCurrencyCircleDollar className="h-6 w-6" />,
        path: "payouts",
        component: <Payout userPermissions={userPermissions} />,
      });

      routes.push({
        isSideBar: true,
        name: "Transactions",
        layout: `/${userRole?.toLowerCase() || ""}`,
        icon: <GrTransaction className="h-5 w-6" />,
        path: "transactions",
        component: <Transaction userPermissions={userPermissions} />,
      });

      routes.push({
        isSideBar: true,
        name: "Providers",
        layout: `/${userRole?.toLowerCase() || ""}`,
        icon: <TbCloudDollar className="h-6 w-6" />,
        path: "providers",
        component: <Navigate to={`/${userRole?.toLowerCase() || ""}/providers/costs`} replace />,
        hasSubMenu: true,
        subMenuItems: [
          {
            name: "Costs",
            layout: `/${userRole?.toLowerCase() || ""}`,
            path: "providers/costs",
          }
        ]
      });

      routes.push({
        isSideBar: false,
        name: "Provider Costs",
        layout: `/${userRole?.toLowerCase() || ""}`,
        icon: <></>,
        path: "providers/costs",
        component: <Fee userPermissions={userPermissions} />,
      });

      routes.push({
        isSideBar: true,
        name: "Batches",
        layout: `/${userRole?.toLowerCase() || ""}`,
        icon: <PiStack className="h-6 w-6" />,
        path: "batch",
        component: <Batch userPermissions={userPermissions} />,
      });

      routes.push({
        isSideBar: false,
        name: "Batch Details",
        layout: `/superadmin`,
        icon: <></>,
        path: "batch/:id",
        component: <BatchDetail userPermissions={userPermissions} />,
      });

      routes.push({
        isSideBar: true,
        name: "Agents",
        layout: `/${userRole?.toLowerCase() || ""}`,
        icon: <TbUserDollar className="h-6 w-6" />,
        path: "agents",
        component: <AgentManagement />,
      });

      routes.push({
        isSideBar: false,
        name: "Agents",
        layout: `/${userRole?.toLowerCase() || ""}`,
        icon: <></>,
        path: "agents/:agent_id",
        component: <AgentDetail userPermissions={userPermissions} />,
      });

      routes.push({
        isSideBar: false,
        name: "Agents",
        layout: `/${userRole?.toLowerCase() || ""}`,
        icon: <></>,
        path: "agents/create",
        component: <CreateAgent />,
      });

      routes.push({
        isSideBar: true,
        name: "Merchants",
        layout: `/${userRole?.toLowerCase() || ""}`,
        icon: <PiUserCircle className="h-6 w-6" />,
        path: "merchants",
        component: <Navigate to={`/${userRole?.toLowerCase() || ""}/merchants/manage`} replace />,
        hasSubMenu: true,
        subMenuItems: [
          {
            name: "Merchants",
            layout: `/${userRole?.toLowerCase() || ""}`,
            path: "merchants/manage",
          },
          {
            name: "Subaccounts",
            layout: `/${userRole?.toLowerCase() || ""}`,
            path: "merchants/subaccounts",
          },
          // {
          //   name: "Setup Wizard",
          //   layout: `/${userRole?.toLowerCase() || ""}`,
          //   path: "merchants/setup-wizard",
          // },
        ]
      });

      routes.push({
        isSideBar: false,
        name: "Merchants",
        layout: `/${userRole?.toLowerCase() || ""}`,
        icon: <></>,
        path: "merchants/manage/create",
        component: <CreateMerchant />,
      });

      routes.push({
        isSideBar: false,
        name: "Setup Wizard",
        layout: `/${userRole?.toLowerCase() || ""}`,
        icon: <></>,
        path: "merchants/setup-wizard",
        component: <SetupWizard />,
      });

      routes.push({
        isSideBar: false,
        name: "Merchants",
        layout: `/${userRole?.toLowerCase() || ""}`,
        icon: <></>,
        path: "merchants/manage",
        component: <MerchantManagement />,
      });

      routes.push({
        isSideBar: false,
        name: "Merchants",
        layout: `/${userRole?.toLowerCase() || ""}`,
        icon: <></>,
        path: "merchants/manage/:merchant_id",
        component: <MerchantDetail />,
      });

      routes.push({
        isSideBar: false,
        name: "Subaccounts",
        layout: `/${userRole?.toLowerCase() || ""}`,
        icon: <></>,
        path: "merchants/subaccounts",
        component: <AccountManagement />,
      });

      routes.push({
        isSideBar: false,
        name: "Subaccounts",
        layout: `/${userRole?.toLowerCase() || ""}`,
        icon: <></>,
        path: "merchants/subaccounts/create",
        component: <CreateAccount />,
      });

      routes.push({
        isSideBar: false,
        name: "Subaccounts",
        layout: `/${userRole?.toLowerCase() || ""}`,
        icon: <></>,
        path: "merchants/subaccounts/:subaccount_id",
        component: <AccountDetail userPermissions={userPermissions} />,
      });

      // Fee Group Menu
      routes.push({
        isSideBar: true,
        name: "Fee Group",
        layout: `/${userRole?.toLowerCase() || ""}`,
        icon: <TbCurrencyDollar className="h-6 w-6" />,
        path: "fee-groups",
        component: <Navigate to={`/${userRole?.toLowerCase() || ""}/fee-groups/subaccount`} replace />,
        hasSubMenu: true,
        subMenuItems: [
          {
            name: "Subaccount",
            layout: `/${userRole?.toLowerCase() || ""}`,
            path: "fee-groups/subaccount",
          },
          {
            name: "Agent",
            layout: `/${userRole?.toLowerCase() || ""}`,
            path: "fee-groups/agent",
          },
          {
            name: "Provider",
            layout: `/${userRole?.toLowerCase() || ""}`,
            path: "fee-groups/provider",
          },
        ]
      });

      // Fee Group - Subaccount routes
      routes.push({
        isSideBar: false,
        name: "Subaccount Fee Group",
        layout: `/${userRole?.toLowerCase() || ""}`,
        icon: <></>,
        path: "fee-groups/subaccount",
        component: <FeeGroupSubaccount userPermissions={userPermissions} />,
      });

      routes.push({
        isSideBar: false,
        name: "Subaccount Fee Group Detail",
        layout: `/${userRole?.toLowerCase() || ""}`,
        icon: <></>,
        path: "fee-groups/subaccount/:feegroup_id",
        component: <FeeGroupSubaccountDetail userPermissions={userPermissions} />,
      });

      routes.push({
        isSideBar: false,
        name: "Create Subaccount Fee Group",
        layout: `/${userRole?.toLowerCase() || ""}`,
        icon: <></>,
        path: "fee-groups/subaccount/create",
        component: <CreateFeeGroupSubaccount userPermissions={userPermissions} />,
      });

      // Fee Group - Agent routes
      routes.push({
        isSideBar: false,
        name: "Agent Fee Group",
        layout: `/${userRole?.toLowerCase() || ""}`,
        icon: <></>,
        path: "fee-groups/agent",
        component: <FeeGroupAgent userPermissions={userPermissions} />,
      });

      routes.push({
        isSideBar: false,
        name: "Agent Fee Group Detail",
        layout: `/${userRole?.toLowerCase() || ""}`,
        icon: <></>,
        path: "fee-groups/agent/:feegroup_id",
        component: <FeeGroupAgentDetail userPermissions={userPermissions} />,
      });

      routes.push({
        isSideBar: false,
        name: "Create Agent Fee Group",
        layout: `/${userRole?.toLowerCase() || ""}`,
        icon: <></>,
        path: "fee-groups/agent/create",
        component: <CreateFeeGroupAgent userPermissions={userPermissions} />,
      });

      // Fee Group - Provider routes
      routes.push({
        isSideBar: false,
        name: "Provider Fee Group",
        layout: `/${userRole?.toLowerCase() || ""}`,
        icon: <></>,
        path: "fee-groups/provider",
        component: <FeeGroupProvider userPermissions={userPermissions} />,
      });

      routes.push({
        isSideBar: false,
        name: "Provider Fee Group Detail",
        layout: `/${userRole?.toLowerCase() || ""}`,
        icon: <></>,
        path: "fee-groups/provider/:feegroup_id",
        component: <FeeGroupProviderDetail userPermissions={userPermissions} />,
      });

      routes.push({
        isSideBar: false,
        name: "Create Provider Fee Group",
        layout: `/${userRole?.toLowerCase() || ""}`,
        icon: <></>,
        path: "fee-groups/provider/create",
        component: <CreateFeeGroupProvider userPermissions={userPermissions} />,
      });

      routes.push({
        isSideBar: true,
        name: "Receivers",
        layout: `/${userRole?.toLowerCase() || ""}`,
        icon: <AiOutlineUserSwitch className="h-6 w-6" />,
        path: "receiver",
        component: <Receiver userPermissions={userPermissions} />,
      });

      routes.push({
        isSideBar: false,
        name: "Receivers",
        layout: `/${userRole?.toLowerCase() || ""}`,
        icon: <></>,
        path: "receiver/:id",
        component: <ReceiverDetail userPermissions={userPermissions} />,
      });

      routes.push({
        isSideBar: true,
        name: "Receiver Accounts",
        layout: `/${userRole?.toLowerCase() || ""}`,
        icon: <MdOutlineSwitchAccount className="h-6 w-6" />,
        path: "find-receiver-account",
        component: <ReceiverAccountSearch userPermissions={userPermissions} />,
      });

      if (userPermissions?.viewTrade) {
        routes.push({
          isSideBar: true,
          name: "Trading Desk",
          layout: `/${userRole?.toLowerCase() || ""}`,
          icon: <MdOutlineSwapHorizontalCircle className="h-6 w-6" />,
          path: "trading-desk",
          component: <Navigate to={`/${userRole?.toLowerCase() || ""}/trading-desk/manage`} replace />,
          hasSubMenu: true,
          subMenuItems: [
            {
              name: "Trades",
              layout: `/${userRole?.toLowerCase() || ""}`,
              path: "trading-desk/trade"
            },
            {
              name: "Desk",
              layout: `/${userRole?.toLowerCase() || ""}`,
              path: "trading-desk/desk",
              badge: "4 Open",
            },
          ]
        });

        routes.push({
          isSideBar: false,
          name: "Trades",
          layout: `/${userRole?.toLowerCase() || ""}`,
          icon: <></>,
          path: "trading-desk/trade",
          component: <Trade userPermissions={userPermissions} />,
        });

        routes.push({
          isSideBar: false,
          name: "Trading Desk",
          layout: `/${userRole?.toLowerCase() || ""}`,
          icon: <></>,
          path: "trading-desk/desk",
          component: <TradingDesk />,
        });
      }

      if (userPermissions?.viewWhitelistAddress) {
        routes.push({
          isSideBar: true,
          name: "Whitelist Addresses",
          layout: `/${userRole?.toLowerCase() || ""}`,
          icon: <HiOutlineClipboardDocumentCheck className="h-6 w-6" />,
          path: "whitelist-addresses",
          component: <WhitelistAddress userPermissions={userPermissions} />,
        });
      }

      routes.push({
        isSideBar: true,
        name: "Activity Logs",
        layout: `/${userRole?.toLowerCase() || ""}`,
        icon: <FiActivity className="h-6 w-6" />,
        path: "activity-logs",
        component: <ActivityLogs />,
      });

      routes.push({
        isSideBar: true,
        name: "User Management",
        layout: `/${userRole?.toLowerCase() || ""}`,
        icon: <PiUsersThree className="h-6 w-6" />,
        path: "user-management",
        component: <UserManagement />,
      });

      routes.push({
        isSideBar: false,
        name: "User Management",
        layout: `/${userRole?.toLowerCase() || ""}`,
        icon: <></>,
        path: "user-management/:user_id",
        component: <UserDetail />,
      });

      routes.push({
        isSideBar: false,
        name: "My Profile",
        layout: `/${userRole?.toLowerCase() || ""}`,
        path: "my-profile",
        icon: <FaRegUser className="h-6 w-6" />,
        component: <Profile />,
      });

      // Hidden route - accessible only by typing URL directly
      routes.push({
        isSideBar: false,
        name: "Admin Utils",
        layout: `/${userRole?.toLowerCase() || ""}`,
        path: "utils",
        icon: <></>,
        component: <AdminUtils />,
      });

      // Hidden route - accessible only by typing URL directly
      routes.push({
        isSideBar: false,
        name: "Create User Without Invitation",
        layout: `/${userRole?.toLowerCase() || ""}`,
        path: "create-user-without-invitation",
        icon: <></>,
        component: <CreateUserWithoutInvitation />,
      });
    } else if (userRole === "Merchant") {
      const merchantPermissions = userPermissions?.[permissionKey] || {};

      routes.push({
        isSideBar: true,
        name: "Dashboard",
        layout: `/${userRole?.toLowerCase() || ""}`,
        path: "dashboard",
        icon: <FaArrowTrendUp className="h-6 w-6" />,
        component: <MainDashboard />,
      });

      routes.push({
        isSideBar: true,
        name: "Payouts",
        layout: `/${userRole?.toLowerCase() || ""}`,
        icon: <PiCurrencyCircleDollar className="h-6 w-6" />,
        path: "payouts",
        component: <Payout userPermissions={merchantPermissions} />,
      });

      routes.push({
        isSideBar: true,
        name: "Transactions",
        layout: `/${userRole?.toLowerCase() || ""}`,
        icon: <GrTransaction className="h-5 w-6" />,
        path: "transactions",
        component: <Transaction userPermissions={merchantPermissions} />,
      });

      routes.push({
        isSideBar: true,
        name: "Batches",
        layout: `/${userRole?.toLowerCase() || ""}`,
        icon: <PiStack className="h-6 w-6" />,
        path: "batch",
        component: <Batch userPermissions={merchantPermissions} />,
      });

      routes.push({
        isSideBar: false,
        name: "Batch Details",
        layout: `/${userRole?.toLowerCase() || ""}`,
        icon: <></>,
        path: "batch/:id",
        component: <BatchDetail userPermissions={merchantPermissions} />,
      });

      routes.push({
        isSideBar: true,
        name: "Subaccounts",
        layout: `/${userRole?.toLowerCase() || ""}`,
        icon: <PiUserCircle className="h-6 w-6" />,
        path: "subaccounts",
        component: <AccountManagement />,
      });

      routes.push({
        isSideBar: false,
        name: "Subaccounts",
        layout: `/${userRole?.toLowerCase() || ""}`,
        icon: <></>,
        path: "subaccounts/create",
        component: <CreateAccount />,
      });

      routes.push({
        isSideBar: false,
        name: "Subaccounts",
        layout: `/${userRole?.toLowerCase() || ""}`,
        icon: <></>,
        path: "subaccounts/:subaccount_id",
        component: <AccountDetail userPermissions={merchantPermissions} />,
      });

      routes.push({
        isSideBar: false,
        name: "My Profile",
        layout: `/${userRole?.toLowerCase() || ""}`,
        path: "my-profile",
        icon: <FaRegUser className="h-6 w-6" />,
        component: <Profile />,
      });

    } else if (userRole === "Agent") {
      routes.push({
        isSideBar: true,
        name: "Dashboard",
        layout: `/${userRole?.toLowerCase() || ""}`,
        path: "dashboard",
        icon: <FaArrowTrendUp className="h-6 w-6" />,
        component: <AgentDashboard />,
      });

      routes.push({
        isSideBar: true,
        name: "Commissions",
        layout: `/${userRole?.toLowerCase() || ""}`,
        icon: <LiaCoinsSolid className="h-6 w-6" />,
        path: "commissions",
        component: <AgentCommission userPermissions={userPermissions} />,
      });

      routes.push({
        isSideBar: false,
        name: "My Profile",
        layout: `/${userRole?.toLowerCase() || ""}`,
        path: "my-profile",
        icon: <FaRegUser className="h-6 w-6" />,
        component: <Profile />,
      });

    } else if (userPermissions && userPermissions[permissionKey]) {

      if (userPermissions[permissionKey].viewDashboard) {
        routes.push({
          isSideBar: true,
          name: "Dashboard",
          layout: `/${userRole?.toLowerCase() || ""}`,
          path: "dashboard",
          icon: <FaArrowTrendUp className="h-6 w-6" />,
          component: <MainDashboard />,
        });
      }

      if (userPermissions[permissionKey].createPayout) {
        routes.push({
          isSideBar: true,
          name: "Create Payout",
          layout: `/${userRole?.toLowerCase() || ""}`,
          icon: <PiCreditCard className="h-6 w-6" />,
          path: "create-payout",
          component: <CreatePayout />,
        });
      }
      if (userPermissions[permissionKey].viewPayout) {
        routes.push({
          isSideBar: true,
          name: "Payouts",
          layout: `/${userRole?.toLowerCase() || ""}`,
          icon: <PiCurrencyCircleDollar className="h-6 w-6" />,
          path: "payouts",
          component: <Payout userPermissions={userPermissions[permissionKey]} />,
        });
      }

      if (userPermissions[permissionKey].viewTransaction) {
        routes.push({
          isSideBar: true,
          name: "Transactions",
          layout: `/${userRole?.toLowerCase() || ""}`,
          icon: <GrTransaction className="h-5 w-6" />,
          path: "transactions",
          component: <Transaction userPermissions={userPermissions[permissionKey]} />,
        });
      }

      if (userPermissions[permissionKey].viewBatch) {
        routes.push({
          isSideBar: true,
          name: "Batches",
          layout: `/${userRole?.toLowerCase() || ""}`,
          icon: <PiStack className="h-6 w-6" />,
          path: "batch",
          component: <Batch userPermissions={userPermissions[permissionKey]} />,
        });

        routes.push({
          isSideBar: false,
          name: "Batch Details",
          layout: `/${userRole?.toLowerCase() || ""}`,
          icon: <></>,
          path: "batch/:id",
          component: <BatchDetail userPermissions={userPermissions[permissionKey]} />,
        });
      }

      if (userPermissions[permissionKey].viewReceiver) {
        routes.push({
          isSideBar: true,
          name: "Receivers",
          layout: `/${userRole?.toLowerCase() || ""}`,
          icon: <AiOutlineUserSwitch className="h-6 w-6" />,
          path: "receiver",
          component: <Receiver userPermissions={userPermissions[permissionKey]} />,
        });
        routes.push({
          isSideBar: false,
          name: "Receivers",
          layout: `/${userRole?.toLowerCase() || ""}`,
          icon: <></>,
          path: "receiver/create",
          component: <CreateReceiver />,
        });
        routes.push({
          isSideBar: false,
          name: "Receivers",
          layout: `/${userRole?.toLowerCase() || ""}`,
          icon: <></>,
          path: "receiver/:id",
          component: <ReceiverDetail userPermissions={userPermissions[permissionKey]} />,
        });
      }

      if (userPermissions[permissionKey].viewUserManagement) {
        routes.push({
          isSideBar: true,
          name: "User Management",
          layout: `/${userRole?.toLowerCase() || ""}`,
          icon: <PiUsersThree className="h-6 w-6" />,
          path: "user-management",
          component: <UserManagement />,
        });
        routes.push({
          isSideBar: false,
          name: "User Management",
          layout: `/${userRole?.toLowerCase() || ""}`,
          icon: <></>,
          path: "user-management/:user_id",
          component: <UserDetail />,
        });
      }

      if (userPermissions[permissionKey].viewTrade) {
        routes.push({
          isSideBar: true,
          name: "Trading Desk",
          layout: `/${userRole?.toLowerCase() || ""}`,
          icon: <MdOutlineSwapHorizontalCircle className="h-6 w-6" />,
          path: "trading-desk",
          component: <Navigate to={`/${userRole?.toLowerCase() || ""}/trading-desk/manage`} replace />,
          hasSubMenu: true,
          subMenuItems: [
            {
              name: "Trades",
              layout: `/${userRole?.toLowerCase() || ""}`,
              path: "trading-desk/trade"
            },
            {
              name: "Desk",
              layout: `/${userRole?.toLowerCase() || ""}`,
              path: "trading-desk/desk",
              badge: "4 Open",
            },
          ]
        });

        routes.push({
          isSideBar: false,
          name: "Trades",
          layout: `/${userRole?.toLowerCase() || ""}`,
          icon: <></>,
          path: "trading-desk/trade",
          component: <Trade userPermissions={userPermissions[permissionKey]}/>,
        });

        routes.push({
          isSideBar: false,
          name: "Trading Desk",
          layout: `/${userRole?.toLowerCase() || ""}`,
          icon: <></>,
          path: "trading-desk/desk",
          component: <TradingDesk />,
        });
      }

      if (userPermissions[permissionKey].viewWhitelistAddress) {
        routes.push({
          isSideBar: true,
          name: "Whitelist Addresses",
          layout: `/${userRole?.toLowerCase() || ""}`,
          icon: <HiOutlineClipboardDocumentCheck className="h-6 w-6" />,
          path: "whitelist-addresses",
          component: <WhitelistAddress userPermissions={userPermissions[permissionKey]} />,
        });
      }

      if (userPermissions[permissionKey].viewSettings) {
        routes.push({
          isSideBar: true,
          name: "Settings",
          layout: `/${userRole?.toLowerCase() || ""}`,
          path: "settings",
          icon: <AiOutlineSetting className="h-6 w-6" />,
          component: <Settings />,
        });
      }

      routes.push({
        isSideBar: false,
        name: "My Profile",
        layout: `/${userRole?.toLowerCase() || ""}`,
        path: "my-profile",
        icon: <FaRegUser className="h-6 w-6" />,
        component: <Profile />,
      });
    }

    return routes;
  };

  const routes: any = {
    public: publicRoutes,
    auth: authRoutes,
    ...(userRole
      ? { [userRole.toLowerCase() || ""]: getRoutesByPermission() }
      : {}),
  };

  return { routes, getRoutesByPermission };
};

export default useRoutes;
